import {TableBody, TableFooter} from '@mui/material';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {notEmpty} from 'main/utility/CommonUtil';
import {getFormattedValue} from 'main/utility/helper/FormatUtil';
import PropTypes from 'prop-types';
import {useMemo} from 'react';
import {UiWiseFieldSummaryCalc} from 'shared/constants/UiWiseConst';

const DocInvTableBody = ({idfieldname, fields, dataSet}) => {
  const totals = useMemo(() => {
    const acc = {};
    dataSet.forEach((row) => {
      fields.forEach((field) => {
        if (field.summarycalc === UiWiseFieldSummaryCalc.SUM) {
          acc[field.name] =
            (acc[field.name] || 0) + (Number(row[field.name]) || 0);
        } else if (field.summarycalc === UiWiseFieldSummaryCalc.COUNT) {
          acc[field.name] = (acc[field.name] || 0) + 1;
        }
      });
    });
    return acc;
  }, [dataSet, fields]);

  const visibleFields = fields.filter((f) => f.visibility === 'show');
  const showFooter = notEmpty(totals);

  return (
    <>
      <TableBody>
        {dataSet.map((row) => (
          <TableRow key={`${row[idfieldname]}`}>
            {visibleFields.map((field) => (
              <TableCell key={field.name} align={field.halignvalue || 'left'}>
                {getFormattedValue(field, row[field.name] || field.value)}
              </TableCell>
            ))}
          </TableRow>
        ))}
      </TableBody>

      {showFooter && (
        <TableFooter>
          <TableRow className='docGrandTotal'>
            {visibleFields.map((field, index) => (
              <TableCell
                key={`${field.name}-footer`}
                align={field.halignvalue || 'left'}
              >
                {index === 0
                  ? 'TOTAL'
                  : totals[field.name]
                  ? getFormattedValue(field, totals[field.name])
                  : ''}
              </TableCell>
            ))}
          </TableRow>
        </TableFooter>
      )}
    </>
  );
};

DocInvTableBody.propTypes = {
  idfieldname: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(PropTypes.object).isRequired,
  dataSet: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default DocInvTableBody;
